class collectionFilter extends HTMLElement {

  constructor() {
    super();
    this.cache = [];
    this.container = this.closest('[data-section-type]');

    this.form = this.querySelector('form');
    this.inputClass = `input[form="${this.form.id}"]`;

    ///POPUP FILTER MOBILE
    this.popupLayer = this.parentElement.querySelector(".filter-popup-layer"); 
    this.popupLayer.addEventListener("click" , () => {
      document.querySelector("body").classList.remove("show-filter-popup");
    })



    this.filterMobile = this.parentElement.querySelector(".filter-mobile");
    this.filterMobile.addEventListener("click" , () => {
      document.querySelector("body").classList.add("show-filter-popup");
    })
    /////////////////

    this.addEvents();


  }
  addEvents(){
    //// Close Popup
    this.closeBtnLayer = this.parentElement.querySelector(".filter-title-closePopup");
    this.closeBtnLayer.addEventListener("click" , () => {
      document.querySelector("body").classList.remove("show-filter-popup");
    })
    //// RESET FILTER
    let resetFilters = this.parentElement.querySelectorAll(".filter-reset");
    resetFilters && resetFilters.forEach(resetFilter => {
       resetFilter.addEventListener("click" , (e) => this.resetFilter(e));
    })
  
    //// REMOVE FILTER
    this.filterActives = this.parentElement.querySelectorAll(".filter-active-removeBtn")
    this.filterActives && this.filterActives.forEach(filter => {
        filter.addEventListener("click" , (e) => this.removeFilter(e))
    })
    /// CHANGE FILTER
    const inps = this.parentElement.querySelectorAll('input[type=checkbox]');

    inps.forEach(inp => {
        inp.addEventListener("change" , (e) => {
            let value = e.currentTarget.value;
            inps.forEach(elm => {
              if (elm.value === value && elm !== e.currentTarget){
                elm.removeAttribute("checked");
              }
            })
            let url = this.queryString();

            //////
            this.fetch(url)

        });
    })

  }
  queryString(){
    const sortBy = this.parentElement.querySelector("#sortBy").value;
    const collectionUrl = this.form.getAttribute("action");
    let formData = new FormData(this.form);
    let query = new URLSearchParams(formData).toString();
    let urlFetch = collectionUrl +"?"+ query + "&sort_by="+ sortBy;
    return urlFetch;
  }

  fetch(url){
    let urlFetchParm = url;
    if (urlFetchParm.includes('?')){
        urlFetchParm += "&";
    }else{
        urlFetchParm += "?";
    }
    
    urlFetchParm += `section_id=${this.container.dataset.sectionId}`;
    fetch(urlFetchParm)
            .then(e => e.text())
            .then(html => {
                
              const div = document.createElement('div');
              div.innerHTML = html;
              let newContent = div.querySelector(".main-content");
              let newPopup = div.querySelector(".filter-popup .filter-container");
              // let filterActives = div.querySelector(".filter-actives");
              // let filterBody = div.querySelector(".filter-body");

              document.querySelector("#CollectionSection .main-content").innerHTML = newContent.innerHTML;
              document.querySelector("#CollectionSection .filter-popup .filter-container").innerHTML = newPopup.innerHTML;
              // let domFilterActives = document.querySelector("#CollectionSection .filter-popup .filter-actives");
              // if (domFilterActives && filterActives ){
              //   domFilterActives.innerHTML = filterActives.innerHTML;
              //   domFilterActives.display.style="block";
              // }else if( !filterActives ){
              //   domFilterActives.display.style="none";
              // }
          

              // let domFilterBody = document.querySelector("#CollectionSection .filter-popup .filter-body");
              // if (domFilterBody && filterBody ){
              //   domFilterBody.innerHTML = filterBody.innerHTML;
              // }
    
              window.history.pushState({}, '', url);
              this.addEvents();
            })
  }
  removeFilter(e){
    let value = e.currentTarget.parentElement.querySelector(".filter-active-text").innerText;
    const inps = this.parentElement.querySelectorAll('input[type=checkbox]');
    inps.forEach(inp => {
      if (inp.value == value){
        inp.removeAttribute("checked");
      }
    })
    let url = this.queryString();
    this.fetch(url);

  }
  resetFilter(e){
    const collectionUrl = this.form.getAttribute("action");
    this.fetch(collectionUrl);
  }
}
customElements.define('collection-filter', collectionFilter);

